import { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { Typography } from '@mui/material';

import FilterListIcon from '@mui/icons-material/FilterList';

import Loading from '../../common/Loading';
import CustomerUsersFilterRoles from './CustomerUsersFilterRoles';

import { useSessionContext } from '../../../contexts/SessionContext';

export default function CustomerUsersFilter(props){
    //console.debug("RTS Break CustomerUsersFilter");

    const {setCurFilter, sessionCustomer} = useSessionContext();

    const [isLoading, setIsLoading] = useState(true);
    const [formDirty, setFormDirty] = useState(0); 

    const [role, setRole] = useState(-1);
    

    useEffect(() => {
        setRole(props.filter.role);
        setIsLoading(false);
    }, [props]);
    

    function setFilter(){
        setFormDirty(0);
        setCurFilter({key:'CustomerUsersPage', filter:{customer:sessionCustomer.customer, role:role}});
        props.setFilterFx({customer:sessionCustomer.customer, role:role});
    };


    if(isLoading){
        return(
            <Loading />
        );
    };


    return (
        <Grid container spacing={2}>
            <Grid item xs={12} sm={4} sx={{textAlign:{xs:'center',sm:'left'}}}>
                <CustomerUsersFilterRoles role={role} setRoleFx={setRole} setFormDirtyFx={setFormDirty} />
            </Grid>
            <Grid item xs={12} sm={4} sx={{textAlign:{xs:'center', sm:'left'}}}>
                <Button type="button" variant="contained" disabled={formDirty===1?false:true} onClick={setFilter}>
                    <FilterListIcon />
                    <Typography sx={{ml:1}}>Filter</Typography>
                </Button>
            </Grid>            
        </Grid>
    );
}
